<!--
 * @Description: 上传凭证页
 * @Author: 山淑兰
 * @Date: 2019-12-09 15:42:11
 * @LastEditTime: 2020-07-02 14:36:56
 * @LastEditors: 山淑兰
 -->
<template>
  <div id="uploadProof">
    <Loading v-if="show"></Loading>

    <div class="uploadProof_container" v-else>
      <div class="banner">
        <!-- <img :src="meetingInfo.MobileBannerImage || require('../../assets/banner.jpg')" alt /> -->
        <img :src="meetingInfo.MobileBannerImage" alt />
      </div>
      <div class="loading" v-if="loading">
        <van-loading
          type="spinner"
          color="#3b82f6"
          vertical
          size="30px"
          text-size="16px"
          >{{ loadingMsg }}</van-loading
        >
      </div>

      <div class="uploadProof_content" v-else>
        <div class="uploadProof_info">
          <ul>
            <li>
              <span>姓名：</span>
              <span>{{ username }}</span>
            </li>
            <li>
              <span>手机号：</span>
              <span>{{ userphone }}</span>
            </li>
          </ul>
        </div>
        <div class="uploadProof_uploadContainer">
          <div class="uploadProof_uploadContainer_title">上传支付凭证：</div>
          <div class="upload_mian">
            <van-icon name="plus" color="#e2e8f0" size="40px" />
            <img :src="proofImg" alt />
            <input
              type="file"
              name
              id
              @change="UploaderImg($event)"
              accept="image/*"
            />
          </div>
          <div class="uploadCaption">
            <p>{{ uploadCaptionText }}</p>
          </div>
        </div>
      </div>
      <Back></Back>
    </div>
  </div>
</template>
<script>
import Loading from '@components/Loading.vue'
import publicSignup from '../../lib/signUp.js'
import Back from './components/backBtn.vue'

export default {
  name: 'uploadProof',
  components: {
    Loading,
    Back,
  },
  data() {
    return {
      show: true, //加载动画
      loading: false,
      loadingMsg: '加载中...',
      m: '',
      publicTools: {}, //通用publicSignup
      meetingInfo: {}, //会议基本信息
      MeetingUserInfo: {}, //获取当前登录账户报名信息接口
      proofImg: '', //上传图片src
      username: '',
      userphone: '',
      uploadCaptionText: '点击+号上传支付凭证',
    }
  },
  created() {
    this.publicTools = new publicSignup()
    this.m = this.$route.query.m
    this.getMeetingInfo()
    this.getUserInfo()
  },

  methods: {
    async getMeetingInfo() {
      this.loading = true
      let opt = {
        m: this.m,
        ch: this.$route.query.ch,
      }
      this.meetingInfo = await this.publicTools.init(opt, this)
      if (this.meetingInfo.Code === 3333) {
        this.$notify({
          message: this.meetingInfo.Msg,
          type: 'danger',
        })
      }
      if (this.meetingInfo) {
        this.show = false
      }
    },
    async getUserInfo() {
      let opt = {
        m: this.m,
      }
      this.MeetingUserInfo = await this.publicTools.GetSignMeetingUserByMu(
        opt,
        this
      )
      console.log('用户信息', this.MeetingUserInfo)

      if (this.MeetingUserInfo.Code === 1000) {
        let _data = this.MeetingUserInfo.CurUserEntity
        this.username = _data.username
        this.userphone = _data.userphone
        this.proofImg = _data.remvoucher
        this.muid = _data.muid
        if (this.proofImg) {
          this.uploadCaptionText = '点击图片重新上传支付凭证'
        }
        this.loading = false
      }
    },

    //上传图片
    async UploaderImg(imgUrl) {
      this.loading = true
      this.loadingMsg = '上传中...'
      let ImgUrl = imgUrl.target.files[0]

      let formdata = new FormData()
      formdata.append('file', ImgUrl)
      formdata.append('name', 'ahhahah')
      console.log('formdata', formdata.get('file').path)
      let res = await this.publicTools.UploadPic(formdata, this)

      if (res.Code === 1000) {
        let params = {
          m: this.m,
          muid: this.muid,
          vouchimg: res.Msg,
        }
        let _res = await this.$http.EditUserVouch(params)
        console.log(_res)

        if (_res.Code === 1000) {
          this.getUserInfo()
          this.$notify({
            message: '上传成功!',
            type: 'success',
            background: '#67C23A',
          })
          this.loading = false
        } else {
          this.loading = false
          this.$notify({
            message: _res.Msg,
            type: 'danger',
            background: '#f56c6c',
          })
        }
      } else {
        this.loading = false
        this.$notify({
          message: res.Msg,
          type: 'danger',
          background: '#f56c6c',
        })
      }
    },
  },
}
</script>
<style lang="scss">
#uploadProof {
  .van-dialog {
    width: 70%;
    text-align: center;
    font-size: 32px;
    padding-top: 20px;
    .van-dialog__content {
      margin: 20px;
    }
    .van-button {
      font-size: 32px;
      line-height: 60px;
      height: 60px;
    }
  }
}
</style>
<style lang="scss" scoped>
#uploadProof {
  min-height: 100vh;
  background-color: #fff;
  .banner {
    > img {
      width: 100%;
    }
  }
  .uploadProof_container {
    .uploadProof_content {
      padding: 20px 0;
      margin: 20px 0;
      .uploadProof_info {
        width: 94%;
        margin: 0 auto;
        margin-bottom: 20px;
        padding-left: 40px;
        font-size: 24px;
        color: #1e293b;
        line-height: 52px;
      }
      .uploadProof_uploadContainer {
        width: 94%;
        margin: 0 auto;
        border-top: 2px solid #e2e8f0;
        padding-top: 20px;
        .uploadProof_uploadContainer_title {
          font-size: 24px;
          margin-bottom: 40px;
          padding-left: 2%;
        }
        .upload_mian {
          width: 410px;
          height: 410px;
          margin: 0 auto;
          text-align: center;
          border: 2px dashed #e2e8f0;
          position: relative;
          > input[type='file'] {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
          }
          > img {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
          }
          > i {
            line-height: 410px;
          }
        }
        .uploadCaption {
          font-size: 28px;
          color: #475569;
          padding: 20px 0 0 2%;
          text-align: center;
        }
      }
    }
  }
}
</style>
